import { isMobileDevice } from "@/app/utils/device";
import useReportRequestQueue from "./useReportRequestQueue";
import {
  ReportBizTypeEnum,
  ReportEventEnum,
  ReportParentContentEnum,
  ReportSceneTypeEnum,
} from "@/app/types/typeConfig/report";
import { isApp } from "@/app/bridge";

interface AIBehaviorCollectHookResult {
  inAI: (parentContentInfo?: {
    parentContent?: string;
    parentContentId?: string;
    parentContentType?: ReportParentContentEnum;
  }) => void;
  exitAI: () => void;
  onLikeCollect: (
    parentContentInfo: {
      parentContent: string;
      parentContentId: string;
      parentContentType: ReportParentContentEnum;
    },
    requestId?: string,
  ) => void;
  onDislikeCollect: (
    parentContentInfo: {
      parentContent: string;
      parentContentId: string;
      parentContentType: ReportParentContentEnum;
    },
    requestId?: string,
  ) => void;
}

const useAIBehaviorCollect = (
  streamingId?: string,
): AIBehaviorCollectHookResult => {
  const AICommonParams = {
    bizType: ReportBizTypeEnum.AI_CHAT,
    createTime: new Date().getTime(),
    scene: ReportSceneTypeEnum.AI_CONSULT,
  };
  const { addToReportQueue } = useReportRequestQueue();
  const inAI = (parentContentInfo?: {
    parentContent?: string;
    parentContentId?: string;
    parentContentType?: ReportParentContentEnum;
  }) => {
    addToReportQueue({
      bizType: ReportBizTypeEnum.TECH_AI,
      createTime: new Date().getTime(),
      eventType: ReportEventEnum.SHOW,
      scene: ReportSceneTypeEnum.AI_CONSULT,
      cacheKey: `${isMobileDevice() ? "mobile" : "pc"}_page_view_scene${ReportSceneTypeEnum.AI_CONSULT}${
        isApp() ? "_handy_app" : ""
      }`,
      parentContent: parentContentInfo?.parentContent,
      parentContentId: parentContentInfo?.parentContentId,
      parentContentType: parentContentInfo?.parentContentType,
      extendField4: streamingId,
    });
  };
  const exitAI = () => {};
  const onLikeCollect = (
    parentContentInfo: {
      parentContent: string;
      parentContentId: string;
      parentContentType: ReportParentContentEnum;
    },
    requestId?: string,
  ) => {
    addToReportQueue({
      ...AICommonParams,
      eventType: ReportEventEnum.UPVOTE,
      parentContent: parentContentInfo.parentContent,
      parentContentId: parentContentInfo.parentContentId,
      parentContentType: parentContentInfo.parentContentType,
      extendField4: streamingId,
    });
    // const template = isMobile()
    //   ? dynamic(() => import(`@mobileComponents/chatTemplate/aiFeedback`))
    //   : dynamic(() => import(`@pcComponents/chatTemplate/aiFeedback`));
    // dispatch(
    //   addQuestion({
    //     type: ComponentTypeEnum.AI,
    //     data: [],
    //     uniqueKey: generateUniqueId(),
    //     template,
    //     templateProps: {
    //       type: IMConfigTypeEnum.techAiFAQ,
    //       likeOrDislike: FeedbackTypeEnum.like,
    //       requestId: requestId || '',
    //     },
    //     parentContentInfo,
    //   }),
    // );
  };
  const onDislikeCollect = (
    parentContentInfo: {
      parentContent: string;
      parentContentId: string;
      parentContentType: ReportParentContentEnum;
    },
    requestId?: string,
  ) => {
    addToReportQueue({
      ...AICommonParams,
      eventType: ReportEventEnum.NEGATIVE_VOTE,
      parentContent: parentContentInfo.parentContent,
      parentContentId: parentContentInfo.parentContentId,
      parentContentType: parentContentInfo.parentContentType,
      extendField4: streamingId,
    });
    addToReportQueue({
      ...AICommonParams,
      eventType: ReportEventEnum.PRE_ADVICE,
      parentContent: parentContentInfo.parentContent,
      parentContentId: parentContentInfo.parentContentId,
      parentContentType: parentContentInfo.parentContentType,
      extendField4: streamingId,
    });
    // const template = isMobile()
    //   ? dynamic(() => import(`@mobileComponents/chatTemplate/aiFeedback`))
    //   : dynamic(() => import(`@pcComponents/chatTemplate/aiFeedback`));
    // dispatch(
    //   addQuestion({
    //     type: ComponentTypeEnum.AI,
    //     data: [],
    //     uniqueKey: generateUniqueId(),
    //     template,
    //     templateProps: {
    //       type: IMConfigTypeEnum.techAiFAQ,
    //       likeOrDislike: FeedbackTypeEnum.dislike,
    //       requestId: requestId || "",
    //     },
    //     parentContentInfo,
    //   }),
    // );
  };
  return {
    inAI,
    exitAI,
    onLikeCollect,
    onDislikeCollect,
  };
};

export default useAIBehaviorCollect;
